import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import Fa from 'react-fontawesome';

import styles from './styles.css';


class ExcludeToggleRenderer extends Component {
  constructor(args) {
    super(args);
    this.state = {};
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    this.props.onToggleValue(this.props.data.value);
  }


  renderContent() {
    const { 
      value, data,
      context: { updatingRowId, updatingColId },
    } = this.props;
    if (!data) {
      return null;
    }
    const active = value;
    
    let icon = active ? 'check-circle' : 'circle-o';
    const iconCls = [styles.checkCellIcon];
    let spin = false;
    const divStyles = {};
    if (updatingRowId === data.value && updatingColId === null) {
      spin = true;
      icon = 'spinner';
      divStyles.cursor = 'not-allowed';
    } else {
      divStyles.cursor = 'pointer';
    }
    if (updatingRowId !== null || updatingColId !== null) {
      iconCls.push('text-muted');
      divStyles.cursor = 'not-allowed';
    } else if (active) {
      iconCls.push('text-success');
    }                  
    return (
      <div className="text-center" style={divStyles} onClick={this.handleOnClick}>
        <Fa name={icon} className={iconCls.join(' ')} spin={spin} />
      </div>
    );
  }
  render() {
    const { node } = this.props;
    const isGrouped = node && node.group;
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}


ExcludeToggleRenderer.propTypes = {
  value: PropTypes.bool,
  data: PropTypes.shape({
    _id: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  node: PropTypes.shape({
    group: PropTypes.bool,
  }).isRequired,
  context: PropTypes.shape({
    updatingColId: PropTypes.string,
    updatingRowId: PropTypes.string,
  }).isRequired,
  onToggleValue: PropTypes.func,
};

ExcludeToggleRenderer.defaultProps = {
  value: false,
  onToggleValue: () => {},
};

export default ExcludeToggleRenderer;
